import React, { useEffect, useState } from "react";
import Header from "../comp/Header";
import Loading from "../comp/Loading";
import About from "../comp/About";
import Services from "../comp/Services";
import Skills from "../comp/Skills";
import Education from "../comp/Education";
import Portfolio from "../comp/portfolio/Portfolio";
import Contact from "../comp/Contact";
import Testimonial from "../comp/testimonials/Testimonial";
import Plans from "../comp/Plans";
import Footer from "../comp/Footer";

const Home = () => {
  const [load, setLoad] = useState(true);
  

  useEffect(() => {
    setTimeout(() => {
      setLoad(false);
    }, 1200);
  }, []);

  if (load) {
    return <Loading />;
  }

  return (
    <>
      <div className="home">
        <Header />
        <About/>
        <Services/>
        <Skills/>
        <Education/>
        <Portfolio/>
        <Testimonial/>
        <Plans/>
        <Contact/>
        <Footer/>
      </div>
    </>
  );
};

export default Home;
